import { Controller } from "@hotwired/stimulus"

/**
 * Revert Confirmation Controller
 * 
 * Manages confirmation dialogs for revert operations.
 * Shows/hides confirmation links when users attempt to revert changes.
 * 
 * Features:
 * - Shows confirmation link on initial click
 * - Hides confirmation link on cancel
 * - Prevents default form submission until confirmed
 * 
 * Usage: Add data-controller="revert-confirmation" to revert forms with confirmation targets
 */
export default class extends Controller {
  static targets = ["confirmLink"]

  showConfirm(event) {
    event.preventDefault()
    this.confirmLinkTarget.classList.remove("d-none")
  }

  hideConfirm(event) {
    event.preventDefault()
    this.confirmLinkTarget.classList.add("d-none")
  }
} 